import(/* webpackMode: "eager" */ "/home/liamto-d-mo-officielle/www/apps/front/src/app/[lng]/error.tsx");
